
import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { motion } from 'framer-motion';

const FAQ = () => {
  const faqs = [
    {
      question: "What is included in the CARFAX report?",
      answer: "A CARFAX report includes comprehensive vehicle history such as accident data, service records, ownership history, title information (salvage, flood, rebuilt), and mileage verification. It's the industry standard for used car buyers."
    },
    {
      question: "How long does it take to receive my report?",
      answer: "Reports are generated instantly! As soon as your payment is confirmed, our system automatically retrieves the data and emails the report to you within minutes. In rare cases requiring manual review, it may take up to 15-30 minutes."
    },
    {
      question: "Is this service official and accurate?",
      answer: "Yes. We provide genuine reports sourced directly from national vehicle databases and NMVTIS (National Motor Vehicle Title Information System). The data is identical to what you would get from dealerships."
    },
    {
      question: "What if the VIN is invalid or no record is found?",
      answer: "If our system cannot locate a record for your VIN or if the VIN is invalid, your payment will not be processed, or you will be eligible for a full and immediate refund. We verify the VIN before charging."
    },
    {
      question: "Can I get a refund if I'm not satisfied?",
      answer: "We offer a 100% satisfaction guarantee. If you do not receive your report or if there is a technical error with the data delivery, simply contact our support team for a full refund."
    }
  ];

  return (
    <div className="bg-white py-16 sm:py-24">
      <div className="mx-auto max-w-3xl px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="mx-auto max-w-2xl text-center mb-12"
        >
          <h2 className="text-3xl font-bold tracking-tight text-[#0A1929] sm:text-4xl">Frequently asked questions</h2>
          <p className="mt-4 text-lg leading-8 text-gray-600">
            Everything you need to know about our vehicle history reports.
          </p>
        </motion.div>
        
        {/* Optimization: 'type="single" collapsible' improves performance by only keeping one item in DOM/layout calculation at a time if preferred, 
            but 'multiple' is fine if content is simple. Used 'single' here to minimize layout shifts. */}
        <Accordion type="single" collapsible className="w-full space-y-4">
          {faqs.map((faq, index) => (
            <AccordionItem 
              key={index} 
              value={`item-${index}`}
              className="border border-gray-200 rounded-lg px-4 data-[state=open]:bg-gray-50 transition-colors duration-200"
            >
              <AccordionTrigger className="text-left text-base font-semibold text-[#0A1929] hover:text-[#FF6B35] hover:no-underline py-4">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-base text-gray-600 pb-4 leading-relaxed">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </div>
  );
};

export default FAQ;
